// extracted by mini-css-extract-plugin
export default {"y-split":"YSplit_y-split__jPeQw"};